import { createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createBlock as _createBlock, toDisplayString as _toDisplayString } from "vue"

const _hoisted_1 = { class: "home-item-top" }
const _hoisted_2 = { class: "home-item-desc" }
const _hoisted_3 = /*#__PURE__*/_createVNode("div", { class: "home-desc-title" }, "[ 活动规则说明 ]", -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createBlock("div", {
    class: "home-wrapper",
    style: `background: ${ _ctx.activityData.templateConfig.backgroundColor } url(${ _ctx.viewConfig.bgs })`
  }, [
    _createVNode("img", {
      src: _ctx.viewConfig.img,
      class: "home-title",
      alt: ""
    }, null, 8, ["src"]),
    _createVNode("div", {
      class: "home-main",
      style: `box-shadow: 1vw 1vw 3vw ${ _ctx.activityData.templateConfig.color };`
    }, [
      _createVNode("div", {
        class: "home-content",
        style: `border: 1px solid ${ _ctx.activityData.templateConfig.color };`
      }, [
        (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.list, (item) => {
          return (_openBlock(), _createBlock("div", {
            class: "home-item",
            key: item,
            onClick: ($event: any) => (_ctx.handleSkip(item.info.link, _ctx.statusText(item.info.statrTime, item.info.endTime))),
            style: `color: ${ _ctx.activityData.templateConfig.color }; background: ${ _ctx.activityData.templateConfig.backgroundColor }`
          }, [
            _createVNode("div", _hoisted_1, [
              _createVNode("div", {
                class: "home-item-name",
                style: `border-bottom: 1px solid ${ _ctx.activityData.templateConfig.color };`
              }, _toDisplayString(item.info.title), 5),
              _createVNode("span", {
                class: "home-item-time",
                style: `background: ${ _ctx.activityData.templateConfig.color }; color: ${ _ctx.activityData.templateConfig.backgroundColor }`
              }, _toDisplayString(_ctx.statusText(item.info.statrTime, item.info.endTime)), 5)
            ]),
            _createVNode("p", _hoisted_2, _toDisplayString(item.info.intro), 1)
          ], 12, ["onClick"]))
        }), 128))
      ], 4)
    ], 4),
    _createVNode("div", {
      class: "home-desc",
      style: `border: 1px dashed ${ _ctx.activityData.templateConfig.color }; color: ${ _ctx.activityData.templateConfig.color };`
    }, [
      _hoisted_3,
      _createVNode("div", {
        innerHTML: _ctx.viewConfig.desc
      }, null, 8, ["innerHTML"])
    ], 4)
  ], 4))
}